import { CourseType } from '@openeducation/oe-rn-shared-types';
import React from 'react';
import { useTheme } from 'react-native-paper';

import { PrivateIcon, PracticeIcon, LiveIcon, LessonIcon } from '../icons';

interface CourseTypeProps {
  type: CourseType;
}
export const CourseTypeIcon = ({ type }: CourseTypeProps) => {
  const { colors } = useTheme();

  switch (type) {
    case CourseType.PRIVATE_CLASS:
      return <PrivateIcon fill={colors.primary} />;
    case CourseType.LIVE_CLASS:
      return <LiveIcon fill={colors.primary} />;
    case CourseType.PRACTICE:
    case CourseType.NEWS:
    case CourseType.IDIOMS:
      return <PracticeIcon fill={colors.primary} />;

    case CourseType.LESSON:
    case CourseType.UNIT_ASSESSMENT:
    case CourseType.LEVEL_ZERO:
    default:
      return <LessonIcon fill={colors.primary} />;
  }
};
